export default "__VITE_ASSET__BT5588Xk__"